var render, staticRenderFns
import script from "./baseVerificacionCliente.vue?vue&type=script&lang=js"
export * from "./baseVerificacionCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f854a53')) {
      api.createRecord('3f854a53', component.options)
    } else {
      api.reload('3f854a53', component.options)
    }
    
  }
}
component.options.__file = "src/components/Flujo/Formularios/VerificacionCliente/baseVerificacionCliente.vue"
export default component.exports